module.exports = __webpack_public_path__ + "img/googlePlayBg.34cc4d91.png";